export default __webpack_public_path__ + "static/media/home-bag@2x.86808024.gif";